import { Text, Progress, Box, Divider, Flex } from '@chakra-ui/react';

const SoftLimit = ({ entitlement, isLimitReached }) => {
  return (
    <>
      <Text textStyle="bodyFamilySemiBold" fontSize="18px">
        {entitlement.name}
      </Text>
      <Divider border="1px solid lightGrey" mt={2} />
      <Box mt={6}>
        <Flex
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text textStyle="heading3">{entitlement.currentValue}</Text>
          <Text
            textStyle="bodySmall"
            color={isLimitReached(entitlement) ? 'dangerRed' : 'darkGrey'}
          >
            of {entitlement.limitValue}
          </Text>
        </Flex>
        <Progress
          variant={isLimitReached(entitlement) ? 'danger' : 'gradient'}
          width="100%"
          borderRadius="4px"
          value={(entitlement.currentValue / entitlement.limitValue) * 100}
          alignSelf="center"
        />
        {entitlement.currentValue >= entitlement.limitValue && (
          <Text textStyle="bodySmall" fontSize="12px" color="dangerRed" mt={3}>
            You have exceeded your limit, upgrade for more.
          </Text>
        )}
      </Box>
    </>
  );
};

export default SoftLimit;
